import styled from 'styled-components';
export const SectionHeader = styled.div.attrs(({ isOnDetailsPage }) => ({
    isOnDetailsPage,
})) `
  background-color: var(--color-neutral-white);
  border-bottom: 1px solid var(--color-grey20);
  height: ${(props) => (props.isOnDetailsPage ? '56px' : '40px')};
  width: 100%;
`;
